(function () {
  if (window.__caStickyBuyboxInit) return;
  window.__caStickyBuyboxInit = true;

  var observed = new WeakSet();
  var observer = new ResizeObserver(function () {
    update();
  });

  function watch(el) {
    if (el && !observed.has(el)) {
      observed.add(el);
      observer.observe(el);
    }
  }

  function update() {
    var entries = [];
    document.querySelectorAll('.product-information__grid > .product-details.sticky-content--desktop').forEach(function (details) {
      var target = details;
      if (details.classList.contains('full-height--desktop')) {
        target = details.querySelector(':scope > .group-block') || details;
      }
      var media = details.parentElement.querySelector(':scope > .product-information__media');
      watch(target);
      watch(media);
      entries.push({
        details: details,
        detailsH: target.offsetHeight,
        media: media,
        mediaH: media ? media.offsetHeight : 0,
      });
    });

    entries.forEach(function (entry) {
      entry.details.style.setProperty('--ca-buybox-h', entry.detailsH + 'px');
      if (entry.media) entry.media.style.setProperty('--ca-media-h', entry.mediaH + 'px');
    });
  }

  document.addEventListener('variant:update', update);
  document.addEventListener('shopify:section:load', update);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();
